import React from 'react';
import { useLanguage } from '../../../i18n/LanguageContext';

export const CoursesFilters: React.FC = () => {
  const { t } = useLanguage();

  // Subject options for filtering
  const subjects = [
    { value: "mathematics", label: t('subjects.mathematics') },
    { value: "science", label: t('subjects.science') },
    { value: "literature", label: t('subjects.literature') },
    { value: "history", label: t('subjects.history') },
    { value: "physics", label: t('subjects.physics') },
    { value: "chemistry", label: t('subjects.chemistry') },
    { value: "biology", label: t('subjects.biology') },
  ];

  // Grade options for filtering
  const grades = [
    { value: "grade1", label: t('grades.grade1') },
    { value: "grade2", label: t('grades.grade2') },
    { value: "grade3", label: t('grades.grade3') },
    { value: "grade4", label: t('grades.grade4') },
    { value: "grade5", label: t('grades.grade5') },
    { value: "grade6", label: t('grades.grade6') },
    { value: "grade7", label: t('grades.grade7') },
    { value: "grade8", label: t('grades.grade8') },
    { value: "grade9", label: t('grades.grade9') },
    { value: "grade10", label: t('grades.grade10') },
    { value: "grade11", label: t('grades.grade11') },
    { value: "grade12", label: t('grades.grade12') },
  ];

  return (
    <div className="bg-white shadow px-4 py-5 sm:rounded-lg sm:p-6 mb-6">
      <div className="md:flex md:items-center md:justify-between space-y-4 md:space-y-0">
        <div className="flex-1">
          <div className="relative rounded-md shadow-sm max-w-lg">
            <input
              type="text"
              name="search"
              id="search"
              className="focus:ring-indigo-500 focus:border-indigo-500 block w-full pl-4 pr-12 sm:text-sm border-gray-300 rounded-md"
              placeholder={t('course-content.searchPlaceholder')}
              aria-label={t('course-content.searchAriaLabel')}
            />
            <div className="absolute inset-y-0 right-0 flex items-center">
              <button 
                className="h-full py-0 pl-3 pr-4 border-transparent bg-transparent text-gray-500 sm:text-sm rounded-r-md"
                aria-label={t('course-content.searchButtonAriaLabel')}
              >
                <svg
                  className="h-5 w-5"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  aria-hidden="true"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                  />
                </svg>
              </button>
            </div>
          </div>
        </div>
        <div className="flex items-center space-x-2">
          <div>
            <select
              id="subject"
              name="subject"
              className="mt-1 block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm rounded-md"
              aria-label={t('course-content.filters.subjectAriaLabel')}
            >
              <option value="">{t('course-content.filters.allSubjects')}</option>
              {subjects.map((subject) => (
                <option key={subject.value} value={subject.value}>
                  {subject.label}
                </option>
              ))}
            </select>
          </div>
          <div>
            <select
              id="grade"
              name="grade"
              className="mt-1 block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm rounded-md"
              aria-label={t('course-content.filters.gradeAriaLabel')}
            >
              <option value="">{t('course-content.filters.allGrades')}</option>
              {grades.map((grade) => (
                <option key={grade.value} value={grade.value}>
                  {grade.label}
                </option>
              ))}
            </select>
          </div>
          <div>
            <select
              id="status"
              name="status"
              className="mt-1 block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm rounded-md"
              aria-label={t('course-content.filters.statusAriaLabel')}
            >
              <option value="">{t('course-content.filters.allStatus')}</option>
              <option value="draft">{t('dashboard.contentStatus.draft')}</option>
              <option value="pending">{t('dashboard.contentStatus.pendingApproval')}</option>
              <option value="approved">{t('dashboard.contentStatus.approved')}</option>
              <option value="published">{t('dashboard.contentStatus.published')}</option>
            </select>
          </div>
        </div>
      </div>
    </div>
  );
}; 